export default "__VITE_ASSET__KsUZTN0U__"